// extracted by mini-css-extract-plugin
module.exports = {"card":"ob_Z69LSI","fullWidth":"ob_JDsvDJ","overlay":"ob_f4Xiv1","mediaAttribution":"ob_pXtlSf"};